import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IEvent } from '../../models/eventdata';
import { EventdataService } from '../../services/eventdata.service';

@Component({
  selector: 'app-summercamp',
  templateUrl: './summercamp.component.html',
  styleUrls: ['./summercamp.component.scss']
})
export class SummercampComponent implements OnInit {
  summercampEventCards: IEvent[] = [];
  showcasedCards: IEvent[] = [];
  nonshowcasedCards: IEvent[] = [];
  filteredEventCards: IEvent[] = [];
  constructor(private _eventservice: EventdataService, public router: Router) { }

  ngOnInit(): void {
    // this._eventservice.GetFabLabSummerCamps().then((res: IEvent[]) => {
    this._eventservice.getTheEvents().then((res: IEvent[]) => {
      this.summercampEventCards = res
     /*    .filter(event => event.published === true && event.section_fab_camp === true && event.isDeleted === false || event.section_Student_durham) */
     .filter(event => event.published === true && event.section_fab_camp === true && event.isDeleted === false)
        //.filter(event => event.published === true)
        .map(event => {
          // Setting the Event Card Images
          event.images = `https://stemprodstoragewest.blob.core.windows.net/photos/${event.images.split("|")[0]}`;
          // Replacing the Commas with Bullet Points in the Event Card
          event.tags = event.tags.split(',').join(' • ');
          return event
        });
      this.showcasedCards = this.summercampEventCards.filter(event => event.isShowcased === true);
      this.nonshowcasedCards = this.summercampEventCards.filter(event => event.isShowcased === false);
      this.filteredEventCards = this.showcasedCards.concat(this.nonshowcasedCards);
      // console.log(this.summercampEventCards);
    });
  }
  toEvent(eventCard: IEvent): void {
    if (eventCard.internal_event === true) {
      this.router.navigate(['/Event', eventCard.eventId]);
    } else if (eventCard.internal_event === false) {
      // window.location.href = eventCard.description_Long;
      window.open(eventCard.description_Long, "_blank")
    }
  }
}